export default "__VITE_ASSET__BA_$102U__"